export default v => (v == null ? "N/A" : v);
